/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Holiday {
    "use strict";

    export class HolidayContext extends Meevo.Components.CommonClasses.CommonContextBase {
        protected addSecurityKey: string;
        protected editSecurityKey: string;
        protected holidayModel: any;
        protected businessTypeDetail: Model.DataDetail;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            if ((identityService.userBusinessTypes.length > 0) || (!identityService.inCentralOfficeMode()))
                this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_HOLIDAYS_TAB_MAIN);
            this.todayDate = moment().startOf("day").toDate();
            // initialize end points
            if (identityService.inCentralOfficeMode() && (identityService.userBusinessTypes.length > 0)) {
                if (Model.Guard.isNothing(this.businessTypeDetail))
                    this.businessTypeDetail = {
                        displayName: identityService.userBusinessTypes[0].displayName,
                        id: identityService.userBusinessTypes[0].id
                    }
                this.baseEndpoint = appSettings.API_ENDPOINTS.holiday + '/' + this.businessTypeDetail.id;

            } else {
                this.baseEndpoint = appSettings.API_ENDPOINTS.holiday + '/' + identityService.businessTypeId;
            }

            // initialize templatepaths
            this.sectionTemplatePath = "app/plugins/holiday/sectionViews/";
            this.initializeSections();
        }

        initializeSections(): void {
            // Adding sections items that represent areas in the maintenance form
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_HOLIDAYS + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new MainSection(0, "SECTION_BUSINFO_HOLIDAYS", "holidays.html", true, false,
                    this.baseEndpoint, "", this.loggingService, this.dataService, Meevo.Model.NounEnum.HolidaysMain, this.identityService, this, this.securityKeys.BUSINESSINFO_HOLIDAYS + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_HOLIDAYS_TAB_MANAGEPASTHOLIDAYS + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ManagePastHolidaysSection(1, 
                    "SECTION_BUSINFO_MANAGE_PAST_HOLIDAYS", 
                    "managePastHolidays.html",
                    true, 
                    false,
                    "PastHolidays/"+this.baseEndpoint, 
                    "",
                    this.loggingService,
                    this.dataService,
                    Meevo.Model.NounEnum.ManagePastHolidays,
                    this.identityService,
                    this,
                    this.securityKeys.BUSINESSINFO_HOLIDAYS_TAB_MANAGEPASTHOLIDAYS + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));

            this.activate();
        }

        selectSection(section): void {
            switch (section.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_HOLIDAYS_TAB_MANAGEPASTHOLIDAYS);
                    break;
                default:
                    this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_HOLIDAYS_TAB_MAIN);
                    break;
            }
            super.selectSection(section);
        }

        initializeHeader(model: any): void {
            if (this.isApplicationModeCO() || this.isSingleLocation())
                model.businessTypeDetail = this.businessTypeDetail;
        }

        canRemoveHoliday(settingLevel: any): boolean {
            if (this.isApplicationModeCO() && this.selectedSection.model.businessTypeDetail == null)
                return;
            let context = this;
            if (this.isSingleLocation())
                return true;
            if ((this.isApplicationModeCO() || this.isSingleLocation()) && settingLevel == 2120 && Model.Guard.isSomething(context.selectedSection.model.businessTypeDetail) && context.selectedSection.model.businessTypeDetail.id == this.identityService.current().tenantData.allBusinessTypeId)
                return true;
            else if (!this.isReadonlyToCommonLocation && settingLevel == 2121)
                return true;
            else if (this.isReadonlyToCommonLocation && settingLevel == 2122)
                return true;
            else
                return false;
        }

        canNotChangeColor(): boolean {
            var canChange = true;
            if (this.isReadonly)
                canChange= true;
            else if (this.isSingleLocation())
                canChange= false;
            else if (this.isApplicationModeCO() && this.selectedSection.model.businessTypeDetail.id == this.identityService.current().tenantData.allBusinessTypeId)
                canChange = false;
            else if (this.isApplicationModeCO() && this.identityService.tenantBusinessTypeCount === 1 && this.identityService.isUserHasBusinessTypeIds())
                canChange = false;

            return canChange;
        }

        /**
        * Gets the appointment book holiday styles
        */
        get apptBookStyle() {
            if (Meevo.Model.Guard.isNothing(this.selectedSection) && Meevo.Model.Guard.isNothing(this.selectedSection.model))
                return;
            return _.find(this.selectedSection.model.styles, s => { return (<Model.HolidayStyle>s).styleType === Model.StyleEnum.HolidayAppointmentBook; });
        }
   
        /**
        * Gets the scheduler holiday styles
        */
        get schedulerStyle() {
            if (Meevo.Model.Guard.isNothing(this.selectedSection) && Meevo.Model.Guard.isNothing(this.selectedSection.model))
                return;
            return _.find(this.selectedSection.model.styles, s => { return (<Model.HolidayStyle>s).styleType === Model.StyleEnum.HolidayScheduleEditor; });
        }

        /**
        * Gets or set the holidayType value
        */
        private _holidayTypeDetail: Model.IntDetail;

        get holidayTypeDetail(): Model.IntDetail {
            return this._holidayTypeDetail;
        }

        set holidayTypeDetail(value: Model.IntDetail) {
            this._holidayTypeDetail = value;
            if (Model.Guard.isNothing(this._holidayTypeDetail))
                return;
            let request = { holidayTypeId: this._holidayTypeDetail.id };
            this.dataService.getListPaged("/Tenant/HolidayTypeHolidays", request)
                .then(response => { this.holidayTypeHolidays = response; });
        }

        /**
        * Gets or set the Holidays for the selected holidayType value
        */
        private _holidayTypeHolidays: Model.HolidayLocal[];

        get holidayTypeHolidays(): Model.HolidayLocal[] {
            return this._holidayTypeHolidays;
        }

        set holidayTypeHolidays(value: Model.HolidayLocal[]) {
            this._holidayTypeHolidays = value;
            this.updateChangeState();
        }

        private updateChangeState() {
            let context = this;
            if (!context || !context._holidayTypeHolidays || !context.selectedSection.model.holidays)
                return;
            var businessHolidays = context.selectedSection.model.holidays;
            if (businessHolidays.length === 0)
                return;
            // When business holidays are available, hide any existing in holidayTypeHolidays
            _.each(context._holidayTypeHolidays, hth => {
                hth.hide = _.any(businessHolidays, h => (<Model.Holiday>h).displayName === hth.displayName);
            });
        }
        /**
        * Opens a modal to create or edit a holiday item.
        * @param context
        */
        openHolidayEditor(context: any, _holiday: Model.Holiday) {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/holiday/sectionViews/holidayEditor.html",
                clickOutsideToClose: false,
                locals: {
                    context: context,
                    holidayItem: _holiday
                },
                controller: "meevo.plugins.HolidayEditorController",
                controllerAs: "vm"
            }
            if (_holiday === null) {
                let trackingItem = new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.HolidaysMain, Meevo.Model.VerbEnum.CreateHolidayButtonClicked, null, null);
                this.trackingService.saveTrackingInfo(trackingItem);
            } else {
                let trackingItem = new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.HolidaysMain, Meevo.Model.VerbEnum.EditHolidayButtonClicked, null, _holiday.id);
                this.trackingService.saveTrackingInfo(trackingItem);
            }
            

            this.modalService.showCustom(options);
        }


        /**
         * Adds a business holiday
         * @param holiday
         * @param index
         */
        addHoliday(holiday: Model.Holiday, index: number): boolean {
            if (Meevo.Model.Guard.isNothing(this.selectedSection) && Meevo.Model.Guard.isNothing(this.selectedSection.model))
                return false;
            if (_.find(this.selectedSection.model.holidays, (h: Model.Holiday) => {
                return h.displayName.toLowerCase() === holiday.displayName.toLowerCase() || moment(h.holidayDate).isSame(moment(holiday.holidayDate), 'day')
            }) === undefined) {

                if (index != null) {
                    this.holidayTypeHolidays[index].hide = true;
                }
                if (!this.holidayDateValidator(holiday)) {
                    return false;
                }

                if (this.identityService.current().isSingleLocation || this.identityService.current().centralOfficeId != this.identityService.current().locationId) {
                    this.selectedSection.model.businessTypeDetail = { id: this.identityService.businessTypeId }
                }
                if (!this.isReadonlyToCommonLocation && (this.selectedSection.model.businessTypeDetail.id == this.identityService.current().tenantData.allBusinessTypeId))
                    holiday.settingLevel = 2120;
                else if (!this.isReadonlyToCommonLocation && (this.selectedSection.model.businessTypeDetail.id != this.identityService.current().tenantData.allBusinessTypeId))
                    holiday.settingLevel = 2121;
                else
                    holiday.settingLevel = 2122;

             if(this.isSingleLocation())
                 holiday.settingLevel = 2120;

                this.selectedSection.model.holidays.push(holiday);
            } else {
                this.modalService.alert('LABEL_HOLIDAY_DATE_VALIDATION_UNIQUE_WARNING',0,true);
                return false;
            }
            return true;
        }
        /**
         * Validate a holiday Date
         * @param holiday
         */
        holidayDateValidator(holiday: Model.Holiday): boolean {
            var checkDate = new Date(holiday.holidayDate);
            var today = new Date();
            if (checkDate <= today) {
                this.modalService.alert('LABEL_HOLIDAY_DATE_PAST_WARNING',0, true);
                return false;
            }
            var twoYearsFromNow = moment().toDate();
            twoYearsFromNow.setFullYear(twoYearsFromNow.getFullYear() + 2);
            if (checkDate > twoYearsFromNow) {
                this.modalService.alert('LABEL_HOLIDAY_DATE_FUTURE_WARNING',0, true);
                return false;
            }
            return true;
        }


        /**
         * Removes a business holiday
         * @param holiday
         */
        removeHoliday(holiday: Model.Holiday): void {
            let trackingItem = new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.HolidaysMain, Meevo.Model.VerbEnum.DeleteHolidayButtonClicked, null, holiday.id);
            this.trackingService.saveTrackingInfo(trackingItem);

            if (Meevo.Model.Guard.isNothing(this.selectedSection) && Meevo.Model.Guard.isNothing(this.selectedSection.model))
                return;

            let that = this;
            _.each(that.holidayTypeHolidays, (h: Model.HolidayLocal, key) => {
                if (h.displayName.toLowerCase() === holiday.displayName.toLowerCase()) {
                    return that.holidayTypeHolidays[key].hide = false;
                }
            })
            let selectedHolidaySet = this.selectedSection.model.holidays;
            var selectedHoliday = moment(holiday.holidayDate).format("MMM Do YY");

            _.each(selectedHolidaySet, (h:Model.Holiday, key) => {
                if (Model.Guard.isSomething(h) && moment(h.holidayDate).format("MMM Do YY") == selectedHoliday) {
                    selectedHolidaySet.splice(key, 1);
                }
            });
        }

        removePastHoliday(holiday: Model.Holiday): void {         
            let selectedHolidaySet = this.selectedSection.model.pastHolidays;
            //selectedHolidaySet[0].isDelete = true;
            var selectedHoliday = moment(holiday.holidayDate).format("MMM Do YY");

            _.each(selectedHolidaySet, (h: Model.Holiday, key) => {
                if (Model.Guard.isSomething(h) && moment(h.holidayDate).format("MMM Do YY") == selectedHoliday) {
                    selectedHolidaySet.splice(key, 1);
                }
            });
        }

        postCancel() {
            this.holidayTypeDetail = undefined;
            super.postCancel();
        }

        save(): angular.IPromise<any> {
                if (Model.Guard.isSomething(this.selectedSection.model.businessTypeDetail))
                    this.selectedSection.baseEndpoint = this.appSettings.API_ENDPOINTS.holiday + '/' + this.selectedSection.model.businessTypeDetail.id;
                else
                this.selectedSection.baseEndpoint = this.appSettings.API_ENDPOINTS.holiday + '/' + this.identityService.businessTypeId;

                if (this.selectedSection.displayNameContentKey === "SECTION_BUSINFO_MANAGE_PAST_HOLIDAYS")
                {
                    this.selectedSection.baseEndpoint = "PastHolidays/" + this.selectedSection.baseEndpoint;
                }            
                    return super.save().then((data: any) => {
                        this.holidayTypeDetail = undefined;
                    });          
        }

        edit(): void {
            var cultureholidayTypeDetail: Model.IntDetail = { displayName: "", id: 1 };
            var cultureCountry = this.appSettings.APP_ISOCOUNTRYCODE;

            switch (cultureCountry) {
                case 'UK':
                case 'GB':
                    cultureCountry = 'UK';
            }
            cultureCountry = cultureCountry + " Holidays";
            this.dataService.customMethodData('api/tenant/holidaytypes/List', 'GET', '', null).then((results: any) => {
                var item = results.data;
                _.find(item, (sl: any) => {
                    if (sl.displayName === cultureCountry) {
                        cultureholidayTypeDetail.id = sl.id;
                        cultureholidayTypeDetail.displayName = sl.displayName;
                        this.holidayTypeDetail = cultureholidayTypeDetail;
                        return true;
                    }
                });
                super.edit();
            });
        }

        updateTextelSystemAutoReply() {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.TEXTEL_UPDATE_SYSTEM_AUTO_REPLY_TIMER);
        }
    }
}